__turbopack_context__.v({
  "container": "_2sUjNa_container",
  "height78": "_2sUjNa_height78",
  "shimmer": "_2sUjNa_shimmer",
  "skeleton": "_2sUjNa_skeleton",
  "width120": "_2sUjNa_width120",
  "width150": "_2sUjNa_width150",
  "width200": "_2sUjNa_width200",
  "width600": "_2sUjNa_width600",
  "width75": "_2sUjNa_width75",
  "width78": "_2sUjNa_width78",
});
